// extracted by mini-css-extract-plugin
export default {"container":"lo-z","ratingLayout":"mo-z","ratingLabel":"no-z","nonInteractiveRatingLabel":"oo-z"};